export default "__VITE_ASSET__BQz7Xg$c__"